// assets/we-b2b-compat.js
(function(){
  // --- Konfiguration: diese IDs stammen aus dem alten Theme (prüfen / anpassen falls nötig)
  const B2B_LOCATION_ID = "84495925521";
  const B2C_LOCATION_ID = "84141048081";

  // Global Objekt initialisieren, falls noch nicht vorhanden
  window.we_b2b = window.we_b2b || {};

  // Location IDs verfügbar machen
  window.we_b2b.b2bLocationId = B2B_LOCATION_ID;
  window.we_b2b.b2cLocationId = B2C_LOCATION_ID;

  // kleines Inventar-Mapping (variantId -> inventory_levels array / object)
  window.we_b2b.inventoryMap = window.we_b2b.inventoryMap || {};

  // Fügt / aktualisiert Inventory-Info für eine Variant
  window.we_b2b.addToDictionary = function(variantId, productInventoryLevel){
    if(!variantId) return;
    window.we_b2b.inventoryMap[variantId.toString()] = productInventoryLevel || {};
  }

  // Prüft inventory_levels
  window.we_b2b.inventoryLevelHasLocation = function(inventoryLevel, locationId){
    if(!inventoryLevel) return false;
    if(Array.isArray(inventoryLevel)){
      return inventoryLevel.some(l => (l.location_id || l.location) == locationId && (l.available || l.quantity || l.available_quantity || l.available > 0));
    } else if (typeof inventoryLevel === 'object' && inventoryLevel.location_id){
      return (inventoryLevel.location_id == locationId) && (inventoryLevel.available && inventoryLevel.available > 0);
    }
    return false;
  }

  // Prüft, ob Variante im B2B-Lager verfügbar ist
  window.we_b2b.variantAvailableAtB2B = function(variantId){
    const key = variantId && variantId.toString();
    const lvl = window.we_b2b.inventoryMap[key];
    if(!lvl) return false;
    return window.we_b2b.inventoryLevelHasLocation(lvl, window.we_b2b.b2bLocationId);
  }

  // Prüft ob Kunde B2B ist
  window.we_b2b.isCustomerB2B = function(){
    if(window.customerTags && Array.isArray(window.customerTags)){
      return window.customerTags.map(t => (t || "").toString().toLowerCase()).includes('b2b');
    }
    if(window.customer && window.customer.tags){
      return (window.customer.tags || []).map(t=>t.toLowerCase()).includes('b2b');
    }
    return false;
  }

  // EventEmitter Stub
  window.we_b2b.we_events = window.we_b2b.we_events || {
    events: {},
    on: function(name,cb){ (this.events[name] = this.events[name]||[]).push(cb); },
    emit: function(name,data){ (this.events[name]||[]).forEach(cb => { try{ cb(data) }catch(e){} }); }
  };



  // -------------------------------------------------------------
  // ⭐ 2A — Inventory aus Product Cards in inventoryMap laden
  // -------------------------------------------------------------
  document.addEventListener("DOMContentLoaded", function () {
    var guards = document.querySelectorAll(".we-b2b-price-guard[data-inventory]");

    guards.forEach(function (el) {
      var variantId = el.getAttribute("data-variant-id");
      var raw = el.getAttribute("data-inventory");
      if (!variantId || !raw) return;

      try {
        var levels = JSON.parse(raw);
        window.we_b2b.addToDictionary(variantId, levels);
      } catch (e) {
        console.warn("B2B: Inventory JSON parsing failed", e);
      }
    });

    setTimeout(updateB2BButtons, 30);
  });



  // -------------------------------------------------------------
  // ⭐ 2B — Buttons für B2C-Kunden ausblenden, wenn B2B-only
  // -------------------------------------------------------------
  function updateB2BButtons() {
    var isB2B = window.we_b2b.isCustomerB2B();

    document.querySelectorAll("[data-we-b2b-btn]").forEach(function (btn) {

      // Varianten-ID ermitteln
      var variantId =
        btn.getAttribute("data-variant-id") ||
        btn.closest(".we-b2b-price-guard")?.getAttribute("data-variant-id");

      if (!variantId) return;

      var b2bOnly = window.we_b2b.variantAvailableAtB2B(variantId);

      // FALL: B2C sieht keinen Button wenn Produkt B2B-only
      if (!isB2B && b2bOnly) {
        btn.style.display = "none";
      } else {
        btn.style.display = "";
      }
    });
  }

  document.addEventListener("DOMContentLoaded", updateB2BButtons);



})();   // ◀◀◀ HIER bleibt die Funktion zu

